import React from 'react';
import PostingElement from './PostingElement';
import Dialog from 'Components/Core/Dialog';
import Form from 'Components/Core/Form/Form';
import FormElement from 'Components/Core/Form/FormElement';
import FormSelectImage from 'Components/Core/Form/FormSelectImage';

export default function NewThreadShort(props) {

	const x = props.x;
	const instanceId = props.forumId || 'default';
	const wafId = "new-thread-short-" + instanceId;
	const fileRenameId = wafId + '-file-rename';
	const smiliesId = wafId + '-smilies';
	const smileyIconId = wafId + '-smiley-icon';
	const fileInputRef = React.useRef(null);
	const pendingFile = React.useRef(null);
	const [colonFilter, setColonFilter] = React.useState(null); // null = inaktiv, sonst der Text nach dem zuletzt getippten ":"

	React.useEffect(() => {

		// if (! x.was.isMobileDevice()) x.waf.focus('new-thread-short', 'posting');

		const handleKey = (event) => {
			if (event.key === '@' && event.target.id === wafId + '-new-posting-short') {
				const forumId = x.wam.getForumId();
				x.wam[forumId].showDialogNewThread();
				if (typeof x.wam[forumId].setTab === 'function') x.wam[forumId].setTab('postings');
				x.wam.activate(forumId);

				event.preventDefault();
			}
		}

		window.addEventListener("keydown", handleKey);


		return () => {
			window.removeEventListener("keydown", handleKey);
		}

	}, [props, x.was, x.wam, wafId]);

	React.useEffect(() => {
		if (x.was.windowWidth > 1000) {
			x.$('#' + wafId + '-new-posting-short').trigger("focus");
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	React.useEffect(() => {
		x.wad[smiliesId + '-dialog'].onClose = () => {
			const composerInput = document.getElementById(wafId + '-new-posting-short');
			if (composerInput) composerInput.focus();
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	function selectFile() {
		if (props.disabled) return;
		fileInputRef.current.click();
	}

	function splitFileName(name) {
		const dotPos = name.lastIndexOf('.');
		if (dotPos <= 0) return { base: name, extension: '' };
		return { base: name.substring(0, dotPos), extension: name.substring(dotPos) };
	}

	function uploadFile(event) {
		const file = event.target.files[0];
		event.target.value = '';
		if (!file) return;

		pendingFile.current = file;
		x.waf.set(fileRenameId, 'filename', splitFileName(file.name).base);
		x.wad[fileRenameId].show(() => {
			x.waf.focus(fileRenameId, 'filename');
			x.waf.select(fileRenameId, 'filename');
		});
	}

	function confirmFileUpload(event) {
		event.preventDefault();
		const file = pendingFile.current;
		if (!file) return;

		const baseName = x.waf.get(fileRenameId, 'filename').trim();
		if (baseName === '') {
			x.wah.addHint('Bitte einen Dateinamen angeben.', true);
			return;
		}
		const fileName = baseName + splitFileName(file.name).extension;

		const formData = new FormData();
		formData.append('file', file, fileName);
		x.was.axPost('Backend/webapp.php?module=Posting&task=UploadFile', formData, (result) => {
			if (result.data.returncode === 1) {
				insertFileLink(result.data.content.fileName, result.data.content.displayName);
				x.wad[fileRenameId].hide();
			}
			else {
				x.wah.addHint(uploadErrorMessage(result.data.returncode), false);
			}
		});
		pendingFile.current = null;
	}

	// Ordnet die spezifischen Fehler-Returncodes von Backend/UploadFile.inc einer
	// verstaendlichen Meldung zu, statt immer nur "Fehler beim Hochladen der Datei" zu zeigen.
	function uploadErrorMessage(returncode) {
		switch (returncode) {
			case -2:
				return 'Datei ist zu groß (maximal 20 MB erlaubt).';
			case -3:
				return 'Nur Bilddateien (JPG, PNG, GIF, WEBP) sind erlaubt. Der Dateiinhalt muss dabei zur Dateiendung passen.';
			default:
				return 'Fehler beim Hochladen der Datei.';
		}
	}

	function insertFileLink(fileName, displayName) {
		const url = 'Backend/download.php?file=' + fileName + '&name=' + encodeURIComponent(displayName);
		const link = '[url=' + url + ']' + displayName + '[/url]';
		const curVal = x.waf.get(wafId, 'new-posting-short');
		x.waf.set(wafId, 'new-posting-short', curVal + (curVal.trim() > '' ? ' ' : '') + link);
		x.waf.focus(wafId, 'new-posting-short');
	}

	function showSmilies(e) {
		if (props.disabled) return;
		x.waf[wafId][smiliesId].show(e, true);
	}

	function countSmileyMatches(filter) {
		// gleiche (nicht case-normalisierte) Logik wie makeSmilies(), damit "0 Treffer" hier
		// exakt dem entspricht, was makeSmilies() tatsaechlich anzeigen wuerde.
		if (filter.length === 0) return Object.keys(x.was.smilies).length;
		return Object.keys(x.was.smilies).filter((key) => key.includes(filter)).length;
	}

	// Wird bei jeder Eingabe im Composer aufgerufen. Solange nach dem letzten ":" (ohne
	// dazwischenliegendes Leerzeichen) noch mindestens ein Smiley passt, bleibt der
	// Smiley-Dialog offen und wird live gefiltert - der Fokus bleibt dabei im Composer.
	function handleComposerChange(value) {
		const inputEl = x.waf[wafId].elements['new-posting-short'].reference.current;
		const cursor = inputEl ? inputEl.selectionStart : value.length;
		const beforeCursor = value.substring(0, cursor);
		const lastColon = beforeCursor.lastIndexOf(':');
		let filter = null;
		if (lastColon !== -1) {
			const between = beforeCursor.substring(lastColon + 1);
			if (!/\s/.test(between)) {
				filter = between;
			}
		}
		if (filter !== null && countSmileyMatches(filter) > 0) {
			if (colonFilter === null) {
				x.wad[smiliesId + '-dialog'].show();
			}
			setColonFilter(filter);
		}
		else if (colonFilter !== null) {
			x.wad[smiliesId + '-dialog'].hide();
			setColonFilter(null);
		}
	}

	function insertSmiley(event, key) {
		event.preventDefault();
		const target = 'new-posting-short';
		const inputEl = x.waf[wafId].elements[target].reference.current;
		const curPos = inputEl.selectionStart;
		const curVal = x.waf.get(wafId, target);
		let leftValue = curVal.substring(0, curPos);
		const rightValue = curVal.substring(curPos);
		if (colonFilter !== null) {
			// den getippten ":filter"-Teil durch den ausgewaehlten Smiley ersetzen
			leftValue = leftValue.substring(0, leftValue.length - colonFilter.length - 1);
		}
		const text = ':-' + key;
		x.waf.set(wafId, target, leftValue + text + rightValue);
		if (colonFilter !== null) {
			x.wad[smiliesId + '-dialog'].hide();
			setColonFilter(null);
			inputEl.focus();
			return;
		}
		// Dialog bleibt offen, damit mehrere Smilies nacheinander ausgewaehlt werden koennen;
		// Fokus geht sonst verloren, da der Klick auf das Icon ihn wegnimmt.
		const searchInput = document.getElementById(smiliesId);
		if (searchInput) searchInput.focus();
	}

	function makeSmilies(filter) {
		const smileyTags = [];
		Object.entries(x.was.smilies).forEach(([key, value]) => {
			if (filter.length === 0 || key.includes(filter)) {
				smileyTags.push(
					<i
						key={key}
						tabIndex="0"
						className="smiley select-smiley "
						dangerouslySetInnerHTML={{ __html: value }}
						title={key}
						alt={key}
						onClick={(e) => insertSmiley(e, key)}
						onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') insertSmiley(e, key); }}
					/>);
			}
		});
		return (
			<div>
				{smileyTags}
			</div>
		)
	}

	function saveNewThread(event) {
		event.preventDefault();
		if (props.disabled) return;
		var forumId = props.forumId;
		if (!forumId) {
			if (x.wam.isForum()) {
				forumId = x.wam.current;
			}
			else {
				forumId = 'forum'
				x.wam.activate(forumId);
				// x.was.activateModule(forumId);
			}
		}
		const newThread = x.waf.get(wafId, 'new-posting-short');
		if (newThread.trim() > '') {
			x.wam[forumId].closeDialogs();
			// console.log('Save new Posting: ' + newThread);
			x.waf.set(forumId + '-new-thread', 'posting', newThread);
			x.waf[forumId + '-new-thread'].send();
			x.waf.set(wafId, 'new-posting-short', '');
			x.was.setNewThreadShort('');
			x.waf.select(wafId, 'new-posting-short');
		}
	}

	/*
	async function newThreadFromClipboard() {
		const cb = await navigator.clipboard.read();
		const type = cb[0].types[0].substring(0, 4).toLowerCase();
		if (type === 'text') {
			const text = await navigator.clipboard.readText();
			pasteText(text);
		}
		if (type === 'image') {
			const text = await navigator.clipboard.readText();
			pasteText(text);
		}
	}
	*/

	return (
		<div id={wafId} className={` new-thread-short `}>
			<input
				type="file"
				ref={fileInputRef}
				style={{ display: 'none' }}
				onChange={uploadFile}
			/>
			<i className={`bi bi-paperclip new-thread-short-icon ${props.disabled ? 'new-thread-short-icon-disabled' : ''}`} title="Datei anhängen" onClick={selectFile}></i>
			<i id={smileyIconId} className={`bi bi-emoji-smile new-thread-short-icon ${props.disabled ? 'new-thread-short-icon-disabled' : ''}`} title="Smilies" onClick={showSmilies}></i>
			<form className={`form-new-thread-short me-2`} onSubmit={e => saveNewThread(e)}>
				<PostingElement
					id="new-posting-short"
					x={x}
					wafId={wafId}
					classes="new-posting new-posting-short"
					maxLength="500"
					placeholder="Neuer Beitrag"
					onFocus={props.onFocus}
					onBlur={props.onBlur}
					onChange={handleComposerChange}
					disabled={props.disabled}
				/>
			</form>
			<FormSelectImage
				id={smiliesId}
				componentId={x.wau.getComponentId()}
				textMode={false}
				x={x}
				moduleId={props.forumId || 'default'}
				callId={smileyIconId}
				wafId={wafId}
				classes="select-smilies select-smilies-short"
				title="Smilies"
				alwayShowSelection={true}
				makeContent={makeSmilies}
				externalFilter={colonFilter}
				autoFocus={colonFilter === null}
			/>
			<Dialog id={fileRenameId} x={x} title="Dateiname" classes="dialog-file-rename">
				<Form
					x={x}
					wafId={fileRenameId}
					enableSendButton={true}
					sendButtonTitle="Datei hochladen"
					onSubmit={confirmFileUpload}
					focusElement="filename"
					classes="form-file-rename"
					checkChanged={() => { return true; }}
				>
					<FormElement
						type="text"
						x={x}
						wafId={fileRenameId}
						id="filename"
						mandatory={true}
						title="Dateiname"
						fieldValue=""
						maxLength="150"
					/>
				</Form>
			</Dialog>
		</div>
	);


}
